import TabSelection from "../../components/SelectContent/TabSelection";
import { setOuberAdminMainTab } from "../../state/slices/generalSlice";
import AdminCalendarOverviewPage from "./admin/AdminCalendarOverviewPage";
import ManageDriverPage from "./admin/ManageDriverPage";
import ManageVehiclePage from "./admin/ManageVehiclePage";
import AdminManageTripReqPage from "./admin/AdminManageTripReqPage";

import {
  CalendarOutlined,
  IdcardOutlined,
  CarOutlined,
  FileTextOutlined,
} from "@ant-design/icons";

function OuberAdminPage() {
  const menuItems = [
    {
      key: "ouber-admin-calendar",
      label: "Calendar Overview",
      component: <AdminCalendarOverviewPage />,
      icon: <CalendarOutlined />,
    },
    {
      key: "ouber-admin-drivers",
      label: "Manage Drivers",
      component: <ManageDriverPage />,
      icon: <IdcardOutlined />,
    },
    {
      key: "ouber-admin-vehicles",
      label: "Manage Vehicles",
      component: <ManageVehiclePage />,
      icon: <CarOutlined />,
    },
    {
      key: "ouber-admin-trip-requests",
      label: "Manage Trip Requests",
      component: <AdminManageTripReqPage />,
      icon: <FileTextOutlined />,
    },
  ];

  return (
    <TabSelection
      menuItems={menuItems}
      currentTabKey="ouberAdminMainTab"
      setTabAction={setOuberAdminMainTab}
    />
  );
}

export default OuberAdminPage;
